import { render, staticRenderFns } from "./view-material-file-popup.vue?vue&type=template&id=0484ba29&scoped=true&"
import script from "./view-material-file-popup.vue?vue&type=script&lang=js&"
export * from "./view-material-file-popup.vue?vue&type=script&lang=js&"
import style0 from "./view-material-file-popup.vue?vue&type=style&index=0&id=0484ba29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484ba29",
  null
  
)

component.options.__file = "view-material-file-popup.vue"
export default component.exports